module.exports = __webpack_public_path__ + "static/media/Bodega.7fb0cf29.webp";